module.exports = __webpack_public_path__ + "img/DN.bfbed95d.png";